<template>
  <v-card class="student-card pa-3">
    <v-row row wrap justify-space-between class="mb-2">
      <v-col cols="10">
        <h3 class="optus-highlight--yellow">
          {{ title }}
        </h3>
        <!-- 
          Replaced Optus logo with old branding
          <v-img
          position="left center"
          contain
          height="30px"
          :src="`${bucketUrl}/brand/logo-dark.svg`"
        /> -->
      </v-col>
      <v-col cols="2">
        <!-- Removed due to optus requirement  -->
        <!-- <v-img
          position="right center"
          contain
          height="30px"
          :src="`${bucketUrl}/brand/logo-ke.png`"
        /> -->
      </v-col>
    </v-row>
    <v-row column align-center>
      <v-col cols="12">
        <div class="card-content">
          <span>
            Student Code:
            <strong>{{ classCode }}</strong>
          </span>
          <span>
            Class Name:
            <strong>{{ className }}</strong>
          </span>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="mt-2 body">
          Visit <strong>{{ url }}</strong> to create a account. Create a
          password and type in your <strong>Student Code</strong> and press
          <strong>'SIGNUP'</strong>. You will be taken to your own
          <strong>Student Dashboard</strong> which will show your new class and
          {{ lessonTerm }}s.
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Config from '@/modules/config/models/Config'
import { mapState } from 'vuex'

export default {
  name: 'StudentCard',
  props: {
    classCode: {
      type: String,
      required: true
    },
    className: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['bucketUrl', 'lessonTerm']),
    title() {
      return Config.value('title')
    },
    url() {
      return `${window.location.origin}/student/signup`
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.student-card {
  border: 1px solid #ccc;
  width: 100%;
  display: block;

  .card-content {
    min-width: 100px;
    font-size: 14px;
    span {
      font-style: normal;
      display: block;
    }
  }

  .body {
    font-size: 11px;
  }
}
</style>
